import PropTypes from 'prop-types';
import React from 'react';
import Immutable from 'immutable';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import ImmutablePropTypes from 'react-immutable-proptypes';
import { accountShape, bibShape, libraryShape, branchShape } from '@bibliocommons/bc-prop-types';

import { selectHoldableItemsForCurrentBib } from 'app/selectors/bibs/HoldableItemsSelector';
import { selectCurrentAccount } from 'app/selectors/AuthSelector';
import { selectBibEntities } from 'app/selectors/EntitiesSelector';
import { selectActiveHoldsByMetadataId, selectHoldsTransactions } from 'app/selectors/HoldsSelector';
import {
  selectCurrentLibrary,
  selectPickupBranches,
  selectActivePreferredBranches
} from 'app/selectors/LibrarySelector';
import BibsActions from 'app/actions/BibsActions';
import HoldActions from 'app/actions/HoldActions';
import ItemLevelHoldsForm from './ItemLevelHoldsForm';

export class ItemLevelHoldsFormContainer extends React.PureComponent {
  componentDidMount() {
    this.props.bibsActions.fetchHoldableItems(this.props.metadataId);
  }

  render() {
    return <ItemLevelHoldsForm {...this.props} />;
  }
}

ItemLevelHoldsFormContainer.propTypes = {
  isFetching: PropTypes.bool.isRequired,
  bib: bibShape.isRequired,
  bibsActions: PropTypes.objectOf(PropTypes.func).isRequired,
  branches: ImmutablePropTypes.listOf(branchShape).isRequired,
  currentAccount: accountShape.isRequired,
  currentLibrary: libraryShape.isRequired,
  handleClose: PropTypes.func.isRequired,
  holdableItems: ImmutablePropTypes.list.isRequired,
  holdActions: PropTypes.objectOf(PropTypes.func).isRequired,
  holds: ImmutablePropTypes.map.isRequired,
  holdsTransactions: ImmutablePropTypes.map.isRequired,
  metadataId: PropTypes.string.isRequired,
  preferredBranches: ImmutablePropTypes.listOf(branchShape).isRequired
};

const mapStateToProps = (state, ownProps) => ({
  isFetching: state.getIn(['bibs', 'holdableItems', 'isFetching'], false),
  bib: selectBibEntities(state).get(ownProps.metadataId),
  holdableItems: selectHoldableItemsForCurrentBib(state),
  branches: selectPickupBranches(state),
  currentAccount: selectCurrentAccount(state),
  currentLibrary: selectCurrentLibrary(state),
  holds: selectActiveHoldsByMetadataId(state).get(ownProps.metadataId, Immutable.Map()),
  holdsTransactions: selectHoldsTransactions(state),
  preferredBranches: selectActivePreferredBranches(state)
});

const mapDispatchToProps = dispatch => ({
  bibsActions: bindActionCreators(BibsActions, dispatch),
  holdActions: bindActionCreators(HoldActions, dispatch)
});

export default connect(mapStateToProps, mapDispatchToProps)(ItemLevelHoldsFormContainer);
